import { VerticalContainer } from '@american-autonomy/ag-ui';

import BodyText from 'components/text/BodyText';
import CaptionText from 'components/text/CaptionText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ChemicalDetailIngredients: FunctionComponent<Props> = ({
    casLabel,
    ingredients,
    testId = TEST_ID,
    title
}) => (
    <VerticalContainer className={styles.ingredientsSection} testId={testId}>
        <BodyText className={styles.sectionTitle} text={title} />

        {ingredients.map(({ casNumber, name, percentage }) => (
            <CaptionText
                key={name}
                text={`${name}${percentage ? ` (${percentage}%)` : ''}${casNumber ? ` — ${casLabel}: ${casNumber}` : ''}`}
            />
        ))}
    </VerticalContainer>
);

export default ChemicalDetailIngredients;
